import { push } from 'react-router-redux';
import Cookies from 'js-cookie';

import forceLogoutHandler from '../users/a.users.forceLogoutHandler';

import {

} from '../actions.export'

////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////
// Update the settings for an installed component
////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////

export const requestUpdateInstalledComponent = packet => {
  return {
    type: 'REQUEST_UPDATE_INSTALLED_COMPONENT',
    data: {
      lastSubmit: packet
    }
  }
}

export const receiveUpdateInstalledComponentSuccess = data => ({
  type: 'RECEIVE_UPDATE_INSTALLED_COMPONENT_SUCCESS',
  data
})

export const receiveUpdateInstalledComponentFail = data => ({
  type: 'RECEIVE_UPDATE_INSTALLED_COMPONENT_FAIL',
  data
})

export const tryToUpdateInstalledComponent = packet => (dispatch, getState) => {

  dispatch(requestUpdateInstalledComponent(packet));

  let headers = {
    "Content-Type": "application/json"
  }
  


  let fs = localStorage.getItem(process.env.REACT_APP_COOKIE_FEATURE_SWITCH);
  if(fs){
    headers["X-NFS"] = fs;
  }


  headers["X-CSRF-TOKEN"] = getState().userReducer.csrf_token;
  return fetch('/api/projects/installed-component/' + packet.id + '/' + packet.component_id, {
      method: 'put',
      body: JSON.stringify(packet),
      headers: headers
    })
    .then((response) => {
      let json = response.json();
      if (response.status >= 200 && response.status < 300) return json;
      return json.then(Promise.reject.bind(Promise));
    })
    .then(function(json){
      dispatch(receiveUpdateInstalledComponentSuccess(json));
    })
    .catch(e => {
      dispatch(forceLogoutHandler(e));
      dispatch(receiveUpdateInstalledComponentFail({errors:e, lastSubmit: packet}));
    })
}
